/*
 * @Author: YangTao
 * @Date: 2022-06-30 14:18:57
 * @LastEditTime: 2022-06-30 14:18:58
 * @LastEditors: YangTao
 * @Description:
 * @FilePath: /react-flow-demo/src/services/login.ts
 * 可以输入预定的版权声明、个性签名、空行等
 */
import { request } from '@/utils/request';

export type LoginParamsType = {
  userName: string;
  password: string;
  mobile: string;
  captcha: string;
};

export async function fakeAccountLogin(params: LoginParamsType) {
  return request('/api/login/account', {
    method: 'POST',
    data: params,
  });
}

export async function getFakeCaptcha(mobile: string) {
  return request(`/api/login/captcha?mobile=${mobile}`);
}

export async function wecommLogOut() {
  return request('/api/sso/open-api/ai_sso/auth/logout_by_token', {
    method: 'POST',
    headers: {
      token: localStorage.getItem('token') ?? '',
    },
  });
}
